import * as echarts from 'echarts'
import { bottomLineData, topLineData } from './data'

interface CreateChartOptionsProps {
  startOffset: number
  valueOffset: number
  endOffset: number
  isDesktop: boolean
}

const BLUE_COLOR = 'rgba(1, 144, 254, 1)'
const WHITE_COLOR = 'rgb(255, 255, 255)'
const TRANSPARENT_COLOR = 'rgb(255, 255, 255, 0)'
const RED_COLOR = 'rgba(254, 85, 82, 1)'
const GRAY_LINE_COLOR = 'rgba(249, 250, 249, 0)'

export const createChartOptions = ({ startOffset, valueOffset, endOffset, isDesktop }: CreateChartOptionsProps) => {
  return {
    yAxis: {
      show: false,
    },
    animation: false,
    series: [
      {
        type: 'line',
        data: [
          [0, 50],
          [5, 55],
          [25, 160],
        ],
        smooth: true,
        silent: true,
        lineStyle: {
          width: 1.5,
          color: GRAY_LINE_COLOR,
        },
        markLine: {
          symbol: 'none',
          data: topLineData,
          lineStyle: {
            color: BLUE_COLOR,
            width: isDesktop ? 2.5 : 1.5,
            type: 'solid',
          },
          emphasis: {
            disabled: true,
          },
          animationDelay: 300,
        },
        showSymbol: false,
        emphasis: {
          disabled: true,
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: TRANSPARENT_COLOR },
            { offset: startOffset, color: TRANSPARENT_COLOR },
            { offset: valueOffset, color: '#0093FF' },
            { offset: endOffset, color: TRANSPARENT_COLOR },
            { offset: 1, color: TRANSPARENT_COLOR },
          ]),
          origin: 'auto',
        },
      },
      {
        type: 'line',
        data: [
          [0, -20],
          [5, -25],
          [25, -130],
        ],
        smooth: true,
        silent: true,
        lineStyle: {
          width: 1.5,
          color: GRAY_LINE_COLOR,
        },
        markLine: {
          symbol: 'none',
          data: bottomLineData,
          lineStyle: {
            color: RED_COLOR,
            width: isDesktop ? 2.5 : 1.5,
            type: 'solid',
          },
          emphasis: {
            disabled: true,
          },
          animationDelay: 300,
        },
        showSymbol: false,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: TRANSPARENT_COLOR },
            { offset: startOffset, color: TRANSPARENT_COLOR },
            { offset: valueOffset, color: RED_COLOR },
            { offset: endOffset, color: TRANSPARENT_COLOR },
            { offset: 1, color: TRANSPARENT_COLOR },
          ]),
          origin: 'auto',
        },
        emphasis: {
          disabled: true,
        },
      },
      {
        type: 'line',
        data: [
          [-1, 1],
          [25, 1],
        ],
        smooth: true,
        silent: true,
        lineStyle: {
          width: isDesktop ? 4 : 3,
          color: WHITE_COLOR,
        },
        z: 5,
        showSymbol: false,
        areaStyle: {
          color: WHITE_COLOR,
          opacity: 1,
        },
        emphasis: {
          disabled: true,
        },
      },
    ],
    xAxis: {
      type: 'value',
      min: 0,
      max: 25,
      axisLine: {
        show: true,
        lineStyle: { color: '#00000', width: 2, opacity: 0 },
      },
      axisTick: { show: false },
      axisLabel: { show: false },
      splitLine: { show: false },
    },
    grid: {
      left: 0,
      top: 0,
      right: 0,
      bottom: 1,
    },
  }
}
